export default {
  setAccounts(state, accounts) {
    state.accounts = accounts

    localStorage.setItem('vitale-linked-accounts', JSON.stringify(accounts))
  },

  setAccount(state, account) {
    state.account = account

    localStorage.setItem('vitale-account', JSON.stringify(account))
    localStorage.setItem('vitale-subdomain', account.tenant_id)
  }
}
